import React from 'react';
import PropTypes from 'prop-types';
import {Form, Select} from 'antd';
import {selectAuth} from '@app/redux/selectors';
import {connect} from 'react-redux';
import {RQUseGetLocationListByDivisionIdAndTypeId} from '@app/reactQuery/apis';
import {SortOptions} from '@app/components/common/Filters/SortOptions';

const SingleSelectDependentMirrorTerritoryAttribute = ({auth, attributeMetadata, formValues}) => {
  const divisionId = formValues[attributeMetadata?.input_parent_division_id];
  const typeId = formValues[attributeMetadata?.input_parent_type_id];
  const mirror = formValues[attributeMetadata?.input_mirror_id];

  const {data} = RQUseGetLocationListByDivisionIdAndTypeId({
    certificate: auth?.certificate,
    divisionId: divisionId,
    typeId: 'loctt00000000000000000000000000000003',
  }
  , {
    enabled: !!(divisionId && typeId && mirror),
  });
  // const dependentData = (attributeMetadata?.input_search_enable)
  //   ? []
  //   : isArray(data)
  //     ? data
  //     : data
  //       ? [data]
  //       : [];
  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <Form.Item
      name={[attributeMetadata.id]}
      label={attributeMetadata.label}
      rules={mirror ? attributeMetadata.validation_rules : []}
    >
      <Select
        showSearch
        filterOption={filterOption}
        placeholder={attributeMetadata?.placeholder}
        disabled={!mirror}
        options={SortOptions(data)?.map((object, index) => {
          return {
            value: object.id.id,
            label: object.parent.name,
          };
        })}
      />
    </Form.Item>
  );
};

SingleSelectDependentMirrorTerritoryAttribute.propTypes = {
  auth: PropTypes.shape({
    certificate: PropTypes.string.isRequired,
  }).isRequired,
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    partName:PropTypes.string,
    editable: PropTypes.bool,
    validation_rules: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    input_search_enable: PropTypes.bool,
    input_parent_division_id: PropTypes.string.isRequired,
    input_parent_type_id: PropTypes.string.isRequired,
    input_mirror_id: PropTypes.bool.isRequired,
  }).isRequired,
  formValues: PropTypes.object,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(SingleSelectDependentMirrorTerritoryAttribute);
